<template>
    <div class="grid">
        <div class="col-12">
            <ul class="m-0 mt-3">
                <li v-for="(key, value) in listaAtributos" :key="key" class="flex" ><h4 class="m-0 mb-3">{{ value }}:</h4><p class="m-0 mb-3 ml-3 ancho">{{ key }}</p></li>
            </ul>
        </div>
    </div>
    
</template>
<script>
export default {
    name: "ListaAtributos",
    props: [
        "jsonSegmento"
    ],
    data() {
        return {
            listaAtributos: null,
        }
    },
    created() {
        this.transformData();
    },
    methods: {
        transformData() {
            this.listaAtributos = JSON.parse(this.jsonSegmento)
        }
    }
}
</script>
<style lang="scss" scoped>
    .ancho{
        max-width: 80%;
        height: auto;
        word-wrap: break-word;
    }
</style>